import { createContext, useContext, useState } from 'react';
import { readUrlState } from '../utils/deepLink';

const CategoryContext = createContext(null);

export function CategoryProvider({ children }) {
  const [category, setCategory] = useState(() => readUrlState().category); // null = nothing selected

  return (
    <CategoryContext.Provider value={{ category, setCategory }}>
      {children}
    </CategoryContext.Provider>
  );
}

export const useCategory = () => useContext(CategoryContext);
